import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { fundsServices } from '!views/Market';
import { ButtonMinus, ButtonPlus } from '»components/atoms/Buttons';
import { TrlSpacer } from '»components/atoms/TrlSpacer';
import { trlChartsServices } from '»components/molecules/TrlChart/trlCharts.services';
import {
  useHandleSagaError,
  useIsTitleNegotiable,
  useNegModalContext,
} from '»utils/customHooks';
import { getFundType } from '»utils/funds';

import { trlSearchInputServices } from '../../trlSearchBar.services';
import { WrapperButtons } from './TrlRightSlot.styles';

export const TrlRightSlot = ({ option, setSelectedOption }) => {
  const theme = useTheme();

  const { openInsertOrderModal } = useNegModalContext();
  const { handleSagaError } = useHandleSagaError();
  const isTitleNegotiable = useIsTitleNegotiable({
    isMarketPrimaryScreen: false,
    isFundsPrimaryScreen: false,
    canTrade: option?.canTrade,
  });

  const isFundTitle = !!getFundType(option);

  const openNegotiationModal = ({ direction }) => {
    const { symbol, exchange, securityType } = option;

    trlSearchInputServices
      .wsbGetInstrumentQuotes({
        symbol,
        exchange,
        securityType,
      })
      .then((resp) => {
        let selectedTitle = {
          ...option,
          askPx: resp[0]?.askPx,
          bidPx: resp[0]?.bidPx,
          lastDateTime: resp[0]?.lastDateTime,
          lastPx: resp[0]?.lastPx,
          lowPx: resp[0]?.lowPx,
          totalVolumeTraded: resp[0]?.totalVolumeTraded,
          variationPctg: resp[0]?.variationPctg,
        };
        setSelectedOption(selectedTitle);
        openInsertOrderModal(direction);

        trlChartsServices
          .instrumentGraphQuotes({
            symbol,
            exchange,
            securityType,
          })
          .then((respChart) => {
            selectedTitle = {
              ...selectedTitle,
              chartData: respChart,
            };
            setSelectedOption(selectedTitle);

            if (isFundTitle)
              fundsServices
                .fundsInfo({
                  securityType: 'FUND',
                })
                .then((funds) => {
                  const matchedFund = funds.find(
                    (fund) =>
                      fund.securityType === selectedTitle.securityType &&
                      fund.symbol === selectedTitle.symbol &&
                      fund.securityExchange === selectedTitle.exchange,
                  );

                  selectedTitle = {
                    ...selectedTitle,
                    ...matchedFund,
                  };
                  setSelectedOption(selectedTitle);
                });
          })
          .catch((error) => {
            handleSagaError(error);
          });
      })
      .catch((error) => {
        handleSagaError(error);
      });
  };

  return (
    <WrapperButtons>
      <ButtonMinus
        isGrid
        disabled={!isTitleNegotiable}
        onClick={() => {
          openNegotiationModal({
            direction: isFundTitle ? 'E' : 2,
          });
        }}
      />
      <TrlSpacer width={theme.spacing()} />
      <ButtonPlus
        isGrid
        disabled={!isTitleNegotiable}
        onClick={() => {
          openNegotiationModal({
            direction: isFundTitle ? 'D' : 1,
          });
        }}
      />
    </WrapperButtons>
  );
};

TrlRightSlot.propTypes = {
  option: PropTypes.object,
  setSelectedOption: PropTypes.func,
};
